import React, { useContext } from "react";
import { ArrowRight } from "lucide-react";
import { LanguageContext } from "../context/LanguageContext";
import { Container } from "./ui/Section";
import { Button } from "./ui/Button";

const CTA = () => {
  const { title, description, startTrial, scheduleDemo, language } = useContext(LanguageContext);
  const prefix = language === "es" ? "/es" : "";

  return (
    <section className="bg-white py-20 md:py-28">
      <Container>
        <div className="relative overflow-hidden rounded-[2rem] bg-brand-navy px-8 py-16 md:px-16 md:py-24">
          {/* The one brand-gradient accent on the page: echoes the logo's oval */}
          <div
            className="pointer-events-none absolute -bottom-40 -right-40 h-[28rem] w-[28rem] rounded-full bg-brand-gradient opacity-90"
            aria-hidden="true"
          />
          <div className="relative max-w-2xl">
            <h2 className="mb-0 font-display text-3xl font-bold leading-[1.08] tracking-tight text-white md:text-5xl">{title}</h2>
            <p className="mb-0 mt-5 text-lg leading-relaxed text-white/70">{description}</p>
            <div className="mt-10 flex flex-col gap-3 sm:flex-row">
              <Button variant="inverse" size="lg" to={`${prefix}/register-owner`}>
                {startTrial}
                <ArrowRight className="h-4 w-4" />
              </Button>
              <Button variant="inverse-outline" size="lg" to="/login">
                {scheduleDemo}
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CTA;
